import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '@src/hooks/useQueryParams';
import UserRegistration from './UserRegistrationForm';
import AccountRegistration from './AccountRegistration';

function Registration() {
  const params = useQueryParams();
  const { push } = useHistory();
  const id = params.get('id');
  const entity = params.get('entity');

  useEffect(() => {
    if (!id || (entity && !['acc', 'sch'].includes(entity))) {
      push('/expiryRedirect');
    }
  }, [id, entity, push])

  return (
    <>
      {!entity && <UserRegistration userId={id as string} />}
      {(entity === 'acc' || entity === 'sch') && <AccountRegistration entityId={id as string} entity={entity} />}
    </>  
  );
}

export default Registration;
